import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Navbar } from "./Navbar";
import { useSessionMonitor } from "../../hooks/useSessionMonitor";
import { useAuthStore } from "../../stores/authStore";

function SessionMonitor() {
  useSessionMonitor();
  return null;
}

function AuthGuard({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading, initFromStorage } = useAuthStore();

  // Initialize auth state from storage on mount
  useEffect(() => {
    initFromStorage();
  }, [initFromStorage]);

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/login", { replace: true });
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show nothing while checking auth state
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-400" />
      </div>
    );
  }

  // Don't render protected content if not authenticated
  if (!isAuthenticated) {
    return null;
  }

  return <>{children}</>;
}

export function Layout() {
  return (
    <AuthGuard>
      <div className="min-h-screen flex flex-col">
        <SessionMonitor />
        <Navbar />
        <main className="flex-1">
          <Outlet />
        </main>
      </div>
    </AuthGuard>
  );
}

export function MapLayout() {
  return (
    <AuthGuard>
      <div className="h-screen flex flex-col overflow-hidden">
        <SessionMonitor />
        <Navbar />
        <main className="flex-1 overflow-hidden relative z-0">
          <Outlet />
        </main>
      </div>
    </AuthGuard>
  );
}

